module.exports = __webpack_public_path__ + "static/media/(V)_MG_5120_-_Pro-Natura_-_Moda_Feminina.7f2d6f13.jpg";